// TODO:
/* eslint-disable no-useless-escape */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class QueryStringHelper {
  getParameterByName(name: string): string | string[] | null {
    const urlParam = window.location.search;
    if (!urlParam || urlParam === 'undefined') return null;
    return this.isSingleValueParameter(name)
      ? this.getSingleParameterValue(name, window.location.href)
      : this.getMultipleParameterValues(name, urlParam);
  }

  private isSingleValueParameter(name: string): boolean {
    return name === 'departureDate' || name === 'returnDate';
  }

  private getSingleParameterValue(name: string, url: string): string | null {
    name = name.replace(/[\[\]]/g, '\\$&').replace(/\\/g, '');
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  private getMultipleParameterValues(
    name: string,
    urlParam: string
  ): string | string[] | null {
    const regex = this.createRegexForMultipleValues(name);
    const values = this.extractValuesFromUrlParam(regex, urlParam);
    if (!values.length) return null;
    return values.length === 1 ? values[0] : values;
  }

  private createRegexForMultipleValues(name: string): RegExp {
    name = name
      .replace(/[\[]/, '\\[')
      .replace(/[\]]/, '\\]')
      .replace(/\\/g, '');
    const pattern = `${name}=([^&#]+)`;
    return new RegExp(pattern, 'ig');
  }

  private extractValuesFromUrlParam(regex: RegExp, urlParam: string): string[] {
    const values: string[] = [];
    let matches;
    while ((matches = regex.exec(urlParam))) {
      if (matches[1]) values.push(matches[1]);
    }
    return values;
  }

  parse_query_string(): Record<string, string | string[]> {
    const urlParam = window.location.search;
    if (!urlParam || urlParam === 'undefined') return {};
    return this.parseQueryStringValues(urlParam.split('&'));
  }

  private parseQueryStringValues(
    vars: string[]
  ): Record<string, string | string[]> {
    const queryString: Record<string, string | string[]> = {};
    vars.forEach((pairStr) => {
      this.updateQueryString(queryString, this.parseQueryPair(pairStr));
    });
    return queryString;
  }

  private updateQueryString(
    queryString: Record<string, string | string[]>,
    [key, value]: [string, string]
  ): void {
    if (!queryString[key]) {
      queryString[key] = value;
    } else if (typeof queryString[key] === 'string') {
      queryString[key] = [queryString[key] as string, value];
    } else {
      (queryString[key] as string[]).push(value);
    }
  }

  private parseQueryPair(pairStr: string): [string, string] {
    const pair = pairStr.split('=');
    const key = decodeURIComponent(pair[0].replace(/\+/g, ' '));
    const value = decodeURIComponent(pair[1]).replace(/\+/g, ' ');
    return [key, value];
  }
}
